import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { AlertTriangleIcon } from 'lucide-react';
import ApplyButton from './ApplyButton';
interface TaleOfTwoOwnersSectionProps {
  scrollToCalendar?: () => void;
}
const TaleOfTwoOwnersSection = ({
  scrollToCalendar
}: TaleOfTwoOwnersSectionProps) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const problems = ['Where your cash is actually going each month', 'How much revenue is slipping through billing gaps', 'What your clinic is really worth to a buyer or lender', 'When you can afford to step back, hire, or expand'];
  return <section className="w-full bg-black py-12 sm:py-20 px-3 sm:px-4" data-id="element-231">
      <div className="max-w-5xl mx-auto" data-id="element-232">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-8 sm:mb-12" data-id="element-233">
          <h2 className="text-white text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 typekit-heading" data-id="element-234">
            The Real Problem
          </h2>
          <p className="text-[#ffdf07] text-lg sm:text-2xl libre-caslon-text-regular font-semibold px-1" data-id="element-235">
            You don't have clear visibility into your clinic's financial health.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="bg-gradient-to-b from-[#111111] to-[#0a0a0a] border border-gray-800 rounded-lg p-6 sm:p-10 mb-8 sm:mb-12 shadow-sm" data-id="element-236">
          <p className="text-gray-300 libre-caslon-text-regular leading-relaxed mb-5 sm:mb-8 text-base sm:text-xl" data-id="element-237">
            You're busy seeing patients and running operations. Your books are
            set up for taxes, not decisions. No one can tell you with
            confidence:
          </p>
          <div className="space-y-4 sm:space-y-5" data-id="element-238">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={inView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.3 + 0.1 * index
          }} className="flex items-start" data-id="element-239">
                <div className="text-red-500 mr-4 sm:mr-5 mt-1 flex-shrink-0" data-id="element-240">
                  <AlertTriangleIcon size={20} className="sm:w-6 sm:h-6" data-id="element-241" />
                </div>
                <p className="text-gray-300 libre-caslon-text-regular leading-relaxed text-base sm:text-xl" data-id="element-242">
                  {problem}
                </p>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.5
      }} className="text-center mb-8 sm:mb-12" data-id="element-243">
          <p className="text-white libre-caslon-text-regular text-base sm:text-xl leading-relaxed px-1" data-id="element-244">
            The{' '}
            <span className="text-[#ffdf07] font-semibold" data-id="element-245">
              Clinic Cash & Capital Sprint
            </span>{' '}
            fixes that in 30 days. You'll know exactly where you stand and what
            to do next.
          </p>
        </motion.div>

        <div className="mt-8 sm:mt-12" data-id="element-246">
          {scrollToCalendar ? <div className="flex justify-center" data-id="element-247">
              <div className="relative" data-id="element-248">
                <div className="button-border-light" data-id="element-249"></div>
                <motion.button onClick={scrollToCalendar} whileHover={{
              scale: 1.05,
              boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
            }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 sm:py-4 px-8 sm:px-12 rounded-md text-base sm:text-lg shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-250">
                  Book My Strategy Call
                </motion.button>
              </div>
            </div> : <ApplyButton data-id="element-251" />}
        </div>
      </div>
    </section>;
};
export default TaleOfTwoOwnersSection;